<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 7C9.55229 7 10 7.44771 10 8V10H12C12.5523 10 13 10.4477 13 11C13 11.5523 12.5523 12 12 12H10V14C10 14.5523 9.55229 15 9 15C8.44772 15 8 14.5523 8 14V12H6C5.44772 12 5 11.5523 5 11C5 10.4477 5.44772 10 6 10H8V8C8 7.44771 8.44772 7 9 7Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 2C14.9443 2 15.8338 2.44478 16.4004 3.2002L20.9004 9.2002C21.7001 10.2667 21.7001 11.7333 20.9004 12.7998L16.4004 18.7998C15.8338 19.5552 14.9443 20 14 20H3C1.34315 20 7.24238e-08 18.6569 0 17V5C-4.87996e-08 3.34315 1.34315 2 3 2H14ZM3 4C2.44772 4 2 4.44772 2 5V17C2 17.5523 2.44772 18 3 18H14C14.3148 18 14.6109 17.8514 14.7998 17.5996L19.2998 11.5996C19.5663 11.2441 19.5663 10.7559 19.2998 10.4004L14.7998 4.40039C14.6109 4.14858 14.3148 4 14 4H3Z" fill="white"/>
  </svg>
</template>

<script>

export default {
  name: 'addTagIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
